import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { NotifyService } from 'common/util/services/notify.service'
import { ClickGallery, ClickGalleryLink, CloudConnection, ElementsUser } from 'elements-sdk'
import { IdentityService } from 'main/services/identity.service'

@Component({
  templateUrl: './createClickLinkModal.component.pug',
})
export class CreateClickLinkModalComponent {
  type: 'email'|'anonymous'|'user' = 'email'
  email = ''
  viewLimit = null
  sendEmail = true
  notifyOnUse = false
  users?: ElementsUser[]

  @Input() gallery: ClickGallery
  @Input() connection: CloudConnection

  constructor (
    public identity: IdentityService,
    private api: APIService,
    private translate: TranslateService,
    private notify: NotifyService,
    private modalInstance: NgbActiveModal,
  ) {
    this.notifyOnUse = !!identity.user?.email
  }

  async ngOnInit () {
    this.users = (await this.api.main.getAllUsers({})).filter(x => !!x.email)
  }

  create = async () => {
    let link: ClickGalleryLink = {
      email: this.type === 'anonymous' ? null : this.email,
      galleryId: this.gallery.id,
      expiresAt: null,
      notifyOnUse: this.notifyOnUse,
      viewsLeft: this.viewLimit,
    }
    link = await this.api.click.createClickGalleryLink({
      connectionId: this.connection.id.toString(),
      clickGalleryLink: link,
    })
    this.modalInstance.close(link)
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
